window.addEventListener("load", function () {
    if ( document.querySelectorAll('.productSlider').length ) {

        const productSlider = document.querySelectorAll('.productSlider');

        productSlider.forEach(function(element) {

            let productImages = new Swiper(element.querySelector(".js-productImages"), {
                slidesPerView: 1,
                watchOverflow: true,
                preloadImages: false,
                checkInView: true,
                loadPrevNext: true,
                lazy: true,
                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                }
            });

        });
    }
});
